import { render, staticRenderFns } from "./ProductSku.vue?vue&type=template&id=59408292&scoped=true&"
import script from "./ProductSku.vue?vue&type=script&lang=js&"
export * from "./ProductSku.vue?vue&type=script&lang=js&"
import style0 from "./ProductSku.vue?vue&type=style&index=0&id=59408292&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59408292",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
